import ScormAPI2004 from '@/lib/ScormApi/ScormAPI2004'
import JsonFormatter from '@/lib/ScormApi/JsonFormatter'
import InteractionsObjectivesObjectInterface
  from "@/lib/ScormApi/Scorm2004/interfaces/InteractionsObjectivesObjectInterface"

export default function InteractionsObjectivesObject (api: ScormAPI2004): InteractionsObjectivesObjectInterface {
  let _id = ''
  return {
    get id () {
      return _id
    },
    set id (id) {
      _id = id
    },
    toJSON: new JsonFormatter().apply
  }
}
